<template>
  <div class="coming-soon-page">
    <div class="image"></div>
    <div class="coming">
      This feature is in development.<br /><br />
      <small>Check back soon!</small>
    </div>
    <div @click="returnHome" class="coming-back">
      <button>
        <i class="fas fa-angles-left"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComingSoon',
  methods: {
    returnHome() {
      // Use the router instance to programmatically navigate
      this.$router.push('/mhome');
    },
  },
};
</script>

<style scoped>
.coming-soon-page {
  display: flex;
  flex-direction: column; /* Arrange children in a column */
  justify-content: center;
  align-items: center;
  height: 100vh; /* Full viewport height */
  background-color: #f0f0f0; /* Light background for contrast */
}

.image {
  border: 1pt solid #7c5d83;
  width: 300px;
  height: 230px;
  margin-top: 100px;
  margin-bottom: 40px;
  background:
    linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)),
    url('/public/compressed/document_manager@0.25x.webp');
  background-size: 330px 220px; /* Ensure the image covers the div */
  background-position: center;
}

.coming {
  text-align: center;
  font-size: 40px; /* Large font size */
  color: #333; /* Text color */
  margin-bottom: 2vh;
}

.coming-back {
  text-align: center;
  font-size: 36pt;
  color: #a778ac;
  margin-bottom: 25vh;
  text-decoration: underline;
}

button {
  margin-top: 20px;
  font-size: 36px;
  border: 1pt solid #a778ac;
  width: 275px;
  padding: 10px;
  border-radius: 5px;
  color: #eee;
  background: #a778ac;
}
</style>
